import {
  Edit,
  Form,
  Image,
  Input,
  Select,
  Switch,
  Table,
  TextField,
  Upload,
  UploadFile,
  UploadProps,
  useForm,
  useSelect,
  useTable,
} from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { useCallback, useEffect, useMemo, useState } from "react";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ILabel } from "types/label.interface";
import { IRelease } from "types/releaase.interface";
import { ITrack, ITrackResponse } from "types/track.interface";
import { beforeUpload } from "utils";

export const ReleaseEdit: React.FC<IResourceComponentsProps> = () => {
  const [fileListArtwork, setFileListArtwork] = useState<UploadFile[]>();

  const { formProps, saveButtonProps, formLoading } = useForm<IRelease>();

  const [label, setLabels] = useState<string>("");

  const { queryResult } = useShow<IRelease>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  const [trackSelect, setTrackSelect] = useState<string[]>([]);

  useEffect(() => {
    if (record?.data?.tracks?.length > 0) {
      const trackIds = (record?.data?.tracks || []).map(
        (track: ITrack) => track._id
      );
      setTrackSelect(trackIds);
    }
  }, [record?.data?.tracks]);

  const handleChangeLabel = useCallback(
    (value: string) => setLabels(value),
    []
  );

  const { tableProps, searchFormProps } = useTable<ITrackResponse>({
    resource: label ? `tracks/search/${label}` : "tracks",
    initialPageSize: 100,
    queryOptions: {
      enabled: !!label, // Chỉ gọi API khi có label
    },
  });

  const trackInRelease = useMemo(() => {
    let trackTable = (tableProps?.dataSource || []).filter((track: any) =>
      trackSelect.includes(track._id)
    );
    return {
      dataSource: trackTable,
    };
  }, [trackSelect, tableProps]);

  const { selectProps: TrackSelectProps } = useSelect<ITrack>({
    resource: label ? `tracks/search/${label}` : "tracks",
    fetchSize: 100,
    optionLabel: "title",
    optionValue: "_id",
    queryOptions: {
      enabled: !!label, // Chỉ gọi API khi có label
    },
  });

  useEffect(() => {
    if (record?.data.artwork) {
      setFileListArtwork([
        { uid: "1", name: "avatar", url: record?.data.artwork },
      ]);
    }
    if (record?.data.label) {
      setLabels(record?.data.label._id);
    }
  }, [record?.data.artwork, record?.data.label]);

  const handleChangeArtwork: UploadProps["onChange"] = ({
    fileList: newFileList,
  }) => setFileListArtwork(newFileList);

  const { selectProps: LabelSelectProps } = useSelect<ILabel>({
    resource: "labels",
    fetchSize: 100,
    optionLabel: "name",
    optionValue: "_id",
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          className="edit-item w48"
          label="isEnabled"
          name="isEnabled"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Switch defaultChecked={record?.data.isEnabled} />
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
            },
          ]}
          style={{ width: "40%" }}
          initialValue={record?.data.title}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: false,
            },
          ]}
          style={{ width: "40%" }}
        >
          <Input defaultValue={record?.data.description} />
        </Form.Item>

        <Form.Item
          label="Artwork"
          name="artwork"
          rules={[
            {
              required: false,
            },
          ]}
          style={{ marginBottom: "30px", width: "30%" }}
        >
          <Upload
            accept="image/*"
            name="artwork"
            listType="picture-card"
            fileList={fileListArtwork}
            beforeUpload={beforeUpload}
            onChange={handleChangeArtwork}
            maxCount={1}
          >
            change
          </Upload>
        </Form.Item>
        <Form.Item
          label="Price"
          name="price"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input defaultValue={record?.data.price} />
        </Form.Item>
        <Form.Item
          label="Label"
          name="label"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Select
            disabled
            options={LabelSelectProps?.options}
            onChange={handleChangeLabel}
            defaultValue={record?.data?.label?._id}
          />
        </Form.Item>

        <Form.Item
          label="Tracks"
          name="tracks"
          rules={[
            {
              type: "array",
              min: 2,
            },
            {
              required: false,
            },
          ]}
        >
          <Select
            mode="multiple"
            {...TrackSelectProps}
            defaultValue={record?.data?.tracks?.map(
              (track: ITrack) => track._id
            )}
            onChange={(value) => {
              searchFormProps?.form?.setFields(value);
              searchFormProps?.form?.submit();
              setTrackSelect(value);
            }}
          />
        </Form.Item>
      </Form>

      <Table {...trackInRelease} rowKey="_id">
        <Table.Column
          dataIndex="artwork"
          key="artwork"
          title="Artwork"
          render={(value, item, index) => <Image width={50} src={value} />}
        />
        <Table.Column
          dataIndex="title"
          key="title"
          title="Title"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="artist"
          key="artist"
          title="Artist"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="previewUrl"
          key="previewUrl"
          title="Preview"
          render={(value) => <audio controls src={value} />}
        />
        <Table.Column
          dataIndex="price"
          key="price"
          title="Price"
          render={(value) => <TextField value={value} />}
        />
      </Table>
    </Edit>
  );
};
